import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';

export const addOnlineItemByExternalId = async (
  lineItemData: ILineItemAddData,
  barcode: string,
): Promise<void> => {
  const onlineItem = {
    ...lineItemData.lineItem.additionalData?.onlineItem,
    authorizationExternalId: barcode,
  };
  const additionalData = {
    ...lineItemData.lineItem.additionalData,
    onlineItem,
  };
  lineItemData.lineItem.additionalData = additionalData;
  return addLineItemToTransaction(lineItemData);
};
